"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import "../leaflet";
const loadEsri = () => __async(void 0, null, function* () {
  var _a, _b;
  const esriModule = yield import("esri-leaflet/dist/esri-leaflet.js");
  const esriVectorModule = yield import("esri-leaflet-vector/dist/esri-leaflet-vector.js");
  if (!window.L.esri) {
    window.L.esri = (esriModule == null ? void 0 : esriModule.esri) || (esriModule == null ? void 0 : esriModule.default) || esriModule;
  }
  if (!window.L.esri.Vector) {
    window.L.esri.Vector = {};
  }
  const vectorTileLayer = (esriVectorModule == null ? void 0 : esriVectorModule.vectorTileLayer) || ((_a = esriVectorModule == null ? void 0 : esriVectorModule.default) == null ? void 0 : _a.vectorTileLayer) || ((_b = esriVectorModule == null ? void 0 : esriVectorModule.Vector) == null ? void 0 : _b.vectorTileLayer);
  if (!vectorTileLayer) {
    throw new Error("esri-leaflet-vector failed to expose vectorTileLayer");
  }
  window.L.esri.Vector.vectorTileLayer = vectorTileLayer;
  return vectorTileLayer;
});
export default loadEsri;
